import {
    PpHttpHeaders,
    PpHttpTokenType,
    PpHttpTokenStorageType,
} from '@penpencil/common';

export const COMMON_CONFIG = {
    headers: new PpHttpHeaders()
        .append('x-header', 'Authorization')
        .append('Client-Type', 'ADMIN'),
    tokenKey: 'pp-token',
    tokenType: PpHttpTokenType.BEARER,
    storedIn: PpHttpTokenStorageType.LOCAL_STORAGE,
};

export const BASE_URLs = {
    production: 'https://api.ycmouonline.ac.in',
    productionDr: 'https://admin-api-dr.penpencil.co',
    staging: 'https://api-stage-ycmou.penpencil.live',
    development: 'https://admin-dev-api.penpencil.co',
};

const FIREBASE_CONFIG = {
    PW: {
        apiKey: 'AIzaSyApsQyaMPr0NBBXi9OR7x7y0Kbc5qfLNc0',
        authDomain: 'physics-wallah-65ada.firebaseapp.com',
        databaseURL: 'https://physics-wallah-65ada.firebaseio.com',
        projectId: 'physics-wallah-65ada',
        storageBucket: 'physics-wallah-65ada.appspot.com',
        messagingSenderId: '252537344732',
        appId: '1:252537344732:web:59fbcdbca9e85979c4da19',
        measurementId: 'G-9RN512817no',
    },
    XYLEM: {
        apiKey: 'AIzaSyC_uyImX-1PNh0BbrtWw1p3MDYLEQMvVh4',
        authDomain: 'xylem-ea81d.firebaseapp.com',
        projectId: 'xylem-ea81d',
        storageBucket: 'xylem-ea81d.appspot.com',
        messagingSenderId: '362917290509',
        appId: '1:362917290509:web:6a7d1ad37e4d1788ca2b44',
        measurementId: 'G-QDNG5VHG1K',
    },
};

const SAARTHI_FREELANCERS = [
    'vikash.jakhar@pw.live',
    'anju.rawat@pw.live',
    'priyanka.jha@pw.live',
    'aarushi.kohli@pw.live',
    'seepu.sahu@pw.live',
    'rajneesh.1@pw.live',
    'chitransh.nigam@pw.live',
    'saarthi_chat_editor001@pw.live',
    'saarthi_chat_editor002@pw.live',
    'saarthi_chat_editor003@pw.live',
    'Saarthi_chat_editor004@pw.live',
    'Saarthi_chat_editor005@pw.live',
    'Saarthi_chat_editor006@pw.live',
    'Saarthi_chat_editor007@pw.live',
    'Saarthi_chat_editor008@pw.live',
    'Saarthi_chat_editor009@pw.live',
    'Saarthi_chat_editor010@pw.live',
    'Saarthi_chat_editor011@pw.live',
    'Saarthi_chat_editor012@pw.live',
    'Saarthi_chat_editor013@pw.live',
    'Saarthi_chat_editor014@pw.live',
    'Saarthi_chat_editor015@pw.live',
    'Saarthi_chat_editor016@pw.live',
    'Saarthi_chat_editor017@pw.live',
    'Saarthi_chat_editor018@pw.live',
    'Saarthi_chat_editor019@pw.live',
    'Saarthi_chat_editor020@pw.live',
    'Saarthi_chat_editor021@pw.live',
    'Saarthi_chat_editor022@pw.live',
    'Saarthi_chat_editor023@pw.live',
    'Saarthi_chat_editor024@pw.live',
    'Saarthi_chat_editor025@pw.live',
];

export const ENVIRONMENT_VARIABLES_PRODUCTION = {
    admin: 'https://admin.ycmouonline.ac.in',
    envType: 'prod',
    htmlResult: 'https://result.penpencil.xyz/',
    mqttUrl: 'wss://emqx.penpencil.net/mqtt',
    multiBatchBaseUrl: 'https://batch-automation.penpencil.co/',
    sdUIAppUrl: 'https://sdui.penpencil.co',
    pwStoreApiBaseUrl: 'https://store-svc.pw.live/',
    videoPlayerBaseUrl: 'https://static-ycmou.penpencil.live/watch/',
    saarthiTeacherBaseUrl: 'https://coaches.physicswallah.live/',
    clientBaseUrl: 'https://www.pw.live/',
    xylemClientBaseUrl: 'https://www.xylem.live/',
    clientApiBaseUrl: 'https://api.ycmouonline.ac.in',
    qbgBaseUrl: 'https://qbg-admin.penpencil.co/',
    nuggetsBaseUrl: 'https://pw-nuggetoverse-admin.penpencil.co/',
    pwTalkBaseUrl: 'https://pw-talk.penpencil.co/',
    skillsAdminBaseUrl: 'https://course-admin.ycmouonline.ac.in/courses',
    staticCdnUrl: 'https://static.pw.live/',
    defaultBatchCategoryIds: [
        '619bedb2394f824a71d8e687',
        '64140cb47ce1e200183332ae',
    ],
    productVariantByCategoryId: '5d5e33f7-5c3d-476c-b0a0-8d92ee3cb6c0',
    webinarId: '6580377b04a137b69872f9b6',
    curiousjrK8WebinarId: '65e84581c0b5cb90f2ac4d41',
    // [ PW REEL TAG, UNIGO REEL TAG ]
    reelTagIds: ['6415928986ac40001880199d', '657af4f22d584a00188e1cab'],
    // [ PW Transcoding TAG ]
    transcodingTagIds: ['659e893b4b8d5a00181b8681'],
    neetPgCatId: 'zdxdazhhsw0abuvnycwqi4ymb',
    podEMUserUId: '63b3fddfd6cacf0018b9a017',
    financeUserId: '67124c9987f4b476969e0505',
    awsSecureVideoBaseUrl: 'https://d3nzo6itypaz07.cloudfront.net/',
    tataSecureVideoBaseUrl: 'https://xylem.pc.cdn.bitgravity.com/',
    roleIds: {
        // COMMON ROLES
        student: '5b27bd965842f950a778c6ef',
        parent: '5cc95a2e8bde4d66de400b37',
        teacher: '5b2b9742764bd519beb90ac2',
        admin: '5b27bd915842f950a778c6eb',
        school: '5dfa049b68d5946c0fa9b381',
        offlineCenterClient: '668f90bcf18fc7f8e9d36647',
        machineUser: '66a1ff1c51e24d48ebe0eca1',
        // PERMISSION ROLES
        academyAdmin: '6423e4ac55871ba2b4a6f454',
        academySuperAdmin: '6423eb2c55871ba2b4a6ff89',
        doubtSme: '636e43376e01d0001fa0588b',
        instituteHead: '640b060facaefe404d162f44',
        instituteTeacher: '64184b0bd67701e3d628f1f7',
        adminGlobalCMS: '651bcf3aa0c4f158bb1941c3',
        adminGyaaneCMS: '682fed014e768ecd391adb85',
        adminGyaaneCreatorCMS: '6848185fa9d3a4ade3deadd0',
        doubtSmeLead: '65ba17a31eeabed538f9ab79',
        operationsAmbassadorAdmin: '65e5836e588ee5017471364a',
        financeAmbassadorAdmin: '65e583be32754c5394cc338c',
        districtAmbassador: '671756429f03b8d1fa637a0b',
        callingAgent: '67175f99788c48248f6a0953',
        engagementSpoc: '67175fb641ccdfa063f54a7e',
        fieldSalesExecutive: '67175fd1788c48248f6a097b',
        referEarnAdmin: '67dc116d2dd6a4080864bcd9',
        // AUTH ROLES
        googleAuthQBG: '637af14a4612a70025a74f36',
        googleAuthSME: '637af17e5aeb2200250c4bbf',
        googleAuthAdmin: '637af18fce9e2f0025441102',
        googleAuthSaarthiTeacher: '637af1b50b128e00258c30cf',
        googleAuthZoomDashboard: '637af1cb5aeb2200250c4bc1',
        superAdmin: '5b27bd885842f950a778c6e7',
        // QBG ROLES
        sme: '629da730012cd250409f8a40',
        qc: '629da714012cd250409f8a3e',
        demand: '62c7d6c91d96210011e759ae',
        dtpFreelancer: '660fd07411f9254564a3c25c',
        qbgAdmin: '6397045f64588000252bc292',
        qbgSubAdmin: '64cb9aad976ffe2d94ed0e4f',
        qbgDc: '6399784b0e8dae002591b8af',
        tagManager: '64b120861fd33e4db6659c05',
        // CRM/SST Roles
        sstSuperAdmin: '657adb78dc85ade8d9640b11',
        sstSuperAgentAlpha: '657adad7dc85ade8d9640b0f',
        sstSuperAgentBeta: '657adb2fdc85ade8d9640b10',
        sstAgent: '648018e7f8111f607a09cdb8',
        saathiOperationAdmin: '681311c30fa7ff9e03afeadd',
        saathiFinanceAdmin: '681311dc0fa7ff9e03afeadf',
        saathiApplicationManager: '681312050fa7ff9e03afeaf0',
        //skills roles
        skillsSuperAdmin: '6893a3ef2c44d931a52adfe1',
        skillsAdmin: '6893a40e2c44d931a52adfe5',
        skillsMentor: '6893a41d2c44d931a52adfee',
        skillsSales: '6893a4292c44d931a52adff0',
        skillsFinance: '6893a4351772e2776adba091',
        skillsTA: '6893a443a39dc4f2a0e38333',
    },
    orgIds: {
        pw: '5eb393ee95fab7468a79d189',
        neetPg: '63b52963e72e8b00186c11f3',
        curiousJr: '65c99dcf0499af0018cc716a',
        gyaane: '682fe3171a5f062f8f5851bf',
        unigo: '6576ef93bf01da0018840930',
        xylem: '64254d66be2a390018e6d348',
        ezpay: '6593b510fefce10018f2a23c',
        ias: '637f1d2bc8c48d00184c944a',
        ambassador: '65dc5778a2696c7fd76b702f',
        marvels: '64b9333f5d629000187dd48c',
        learnOs: '6593b4a9e678280018742c4c',
        talk: '66cec0359fd5f90018802445',
        scaleIndia: '6717e7f8516487b11d33dd8c',
        ccs: '6745a0c89aa95dfb81b3244d',
        nursingNext: '5ee9a14f0e10190011c078d1',
        disha: '6859283d682172331191b01e',
        pwmedharthi: '682e9b1adf1494180ab1a66d',
        ycmou: '68886e07858959e616e78388',
    },
    isSecureLiveCreateEnabled: true,
    isDeleteChannelEnabled: true,
    isUsernameLoginEnabled: true,
    isMockAndRegularEnabled: true,
    isEnableQuestionPaperEnabled: true,
    isMentorJoinSessionsEnabled: true,
    isMentorReplaceTimeBound: true,
    isMultiRoleEnabled: true,
    firebase: FIREBASE_CONFIG,
    isSuper40Enabled: false,
    isLcmChatsEnabled: true,
    client_id:
        '626063976766-b8s9bf68eepiurla4dreq8s1l2gq56mi.apps.googleusercontent.com',
    saarthiFreelancers: SAARTHI_FREELANCERS,
    countryCodeAndName: 'https://countriesnow.space/api/v0.1/',
    odysseyUrl: 'https://studio.pw.live',
    paidUserSegmentId: '660bc1c25fbb68d0b25ce2f3',
    freeUserSegmentId: '660bc1f48e1fb074b256acb6',
    noBatchUserSegmentId: '660bc21b8e1fb074b256acba',
    isNewWeeklyScheduleEnabledByDefault: false,
    uSocketUrl: 'wss://central-socket.penpencil.co/central-socket/ws',
    videoCookiesKey: {
        VIDEO_ENCRYPTION_KEY: 'pw3c199c2911cb437a907b1k0907c17n',
        INITIALISATION_VECTOR: '5184781c32kkc4e8',
    },
    slideImageUrl: 'https://slide-image.pw.live/',
    completeProgramId: '5eb3b1017b1fb86475ec30eb',
    aiNcertProgramId: '679a677a5a5ba55d1f51e3fe',
    logsDashboard: 'https://metabase-prod.penpencil.co/dashboard',
    financeExamEditAccessGiveTo: ['68186c6ec1ac89cca8302867'],
    batchCohortIdSC: '65e99476c863730018401036',
    batchCohortIdEBC: '66fc2b33a65357d9a307eefb',
    batchCohortIdMM: '66fc2a398b612402e9561576',
    defaultVideoPlayerPoster:
        'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/7b8768ab-a16a-433a-a9fd-30f232596109.webp',
};

export const ENVIRONMENT_OVERRIDES_PRE_PROD = {
    slideImageUrl: 'https://slide-image-demo.pw.live/',
    videoPlayerBaseUrl: 'https://demo.pw.live/watch/',
    odysseyUrl: 'https://studio-pre-prod.pw.live',
    aiNcertProgramId: '679a677a5a5ba55d1f51e3fe',
    isLcmChatsEnabled: true,
};

export const ENVIRONMENT_OVERRIDES_PRODUCTION_DR = {
    odysseyUrl: 'https://studio-dr.pw.live',
    qbgBaseUrl: 'https://qbg-admin-dr.penpencil.co/',
};

export const ENVIRONMENT_VARIABLES_STAGING = {
    admin: 'https://admin-v2-stage.penpencil.co/',
    envType: 'stage',
    htmlResult: 'https://result-staging.penpencil.xyz/',
    mqttUrl: 'wss://emqx.penpencil.net/mqtt',
    multiBatchBaseUrl: 'https://batch-automation-stage.penpencil.co/',
    sdUIAppUrl: 'https://stage-sdui.penpencil.co',
    pwStoreApiBaseUrl: 'https://pw-store-stage.penpencil.co/',
    videoPlayerBaseUrl: 'https://static-stage-ycmou.penpencil.live/watch/',
    saarthiTeacherBaseUrl: 'https://sarthi-teacher-stage.penpencil.co/',
    clientBaseUrl: 'https://staging.physicswallah.live/',
    xylemClientBaseUrl: 'https://stage.xylem.live/',
    clientApiBaseUrl: 'https://stage-api.penpencil.co/',
    qbgBaseUrl: 'https://qbg-admin-stage.penpencil.co/',
    nuggetsBaseUrl: 'https://stage-pw-nuggetoverse-admin.penpencil.co/',
    pwTalkBaseUrl: 'https://pw-talk-stage.penpencil.co/',
    skillsAdminBaseUrl:
        'https://course-admin-fe-stage-ycmou.penpencil.live/courses',
    staticCdnUrl: 'https://static.pw.live/',
    defaultBatchCategoryIds: [
        '619bedb2394f824a71d8e687',
        '64140cb47ce1e200183332ae',
    ],
    productVariantByCategoryId: '746d0c88-cec3-4f7b-bd0f-7daa11a24ad0',
    webinarId: '65701493ad71cf38c2ee884c',
    curiousjrK8WebinarId: '65c9dfe1e9bc8c2c56cb4f30',
    // [ PW REEL TAG, UNIGO REEL TAG ]
    reelTagIds: ['64102b5aa336680019b4a0dd', '65782d323511de388f9a5220'],
    // [ PW Transcoding TAG ]
    transcodingTagIds: ['659e84101e7cd256db78a7b9'],
    neetPgCatId: 'zdxdazhhsw0abuvnycwqi4ymb',
    podEMUserUId: '6578963be8f602d3bb8dd6fd',
    financeUserId: '',
    awsSecureVideoBaseUrl: 'https://d3nzo6itypaz07.cloudfront.net/',
    tataSecureVideoBaseUrl: 'https://xylem.pc.cdn.bitgravity.com/',
    roleIds: {
        // COMMON ROLES
        student: '5b27bd965842f950a778c6ef',
        parent: '5cc95a2e8bde4d66de400b37',
        teacher: '5b2b9742764bd519beb90ac2',
        admin: '5b27bd915842f950a778c6eb',
        school: '5dfa049b68d5946c0fa9b381',
        offlineCenterClient: '668f90bcf18fc7f8e9d36647',
        machineUser: '66a1ff1c51e24d48ebe0eca1',
        // PERMISSION ROLES
        academyAdmin: '6423e4ac55871ba2b4a6f454',
        academySuperAdmin: '6423eb2c55871ba2b4a6ff89',
        doubtSme: '636e43376e01d0001fa0588b',
        instituteHead: '640b060facaefe404d162f44',
        instituteTeacher: '64184b0bd67701e3d628f1f7',
        adminGlobalCMS: '651bcf3aa0c4f158bb1941c3',
        adminGyaaneCMS: '682fed014e768ecd391adb85',
        adminGyaaneCreatorCMS: '6848185fa9d3a4ade3deadd0',
        doubtSmeLead: '65ba17a31eeabed538f9ab79',
        operationsAmbassadorAdmin: '65e5836e588ee5017471364a',
        financeAmbassadorAdmin: '65e583be32754c5394cc338c',
        districtAmbassador: '671756429f03b8d1fa637a0b',
        callingAgent: '67175f99788c48248f6a0953',
        engagementSpoc: '67175fb641ccdfa063f54a7e',
        fieldSalesExecutive: '67175fd1788c48248f6a097b',
        referEarnAdmin: '67dc116d2dd6a4080864bcd9',
        // AUTH ROLES
        googleAuthQBG: '637af14a4612a70025a74f36',
        googleAuthSME: '637af17e5aeb2200250c4bbf',
        googleAuthAdmin: '637af18fce9e2f0025441102',
        googleAuthSaarthiTeacher: '637af1b50b128e00258c30cf',
        googleAuthZoomDashboard: '637af1cb5aeb2200250c4bc1',
        superAdmin: '5b27bd885842f950a778c6e7',
        // QBG ROLES
        sme: '63f373e6ea2e3e00125cdd7c',
        qc: '63f373ea890c260019877433',
        demand: '63f373eeada19a0012b94dde',
        dtpFreelancer: '660f8d6180d7ddb8ab34536e',
        qbgAdmin: '63f373d457108f0019796eaf',
        qbgSubAdmin: '64cc94e5f5039d4de1c1d590',
        qbgDc: '63f373dc245ca10019b0c811',
        tagManager: '648ad54132096ea9cb9a1d4e',
        // CRM/SST Roles
        sstSuperAdmin: '657adb78dc85ade8d9640b11',
        sstSuperAgentAlpha: '657adad7dc85ade8d9640b0f',
        sstSuperAgentBeta: '657adb2fdc85ade8d9640b10',
        sstAgent: '648018e7f8111f607a09cdb8',
        saathiOperationAdmin: '681311c30fa7ff9e03afeadd',
        saathiFinanceAdmin: '681311dc0fa7ff9e03afeadf',
        saathiApplicationManager: '681312050fa7ff9e03afeaf0',
        //skills roles
        skillsSuperAdmin: '6893a3ef2c44d931a52adfe1',
        skillsAdmin: '6893a40e2c44d931a52adfe5',
        skillsMentor: '6893a41d2c44d931a52adfee',
        skillsSales: '6893a4292c44d931a52adff0',
        skillsFinance: '6893a4351772e2776adba091',
        skillsTA: '6893a443a39dc4f2a0e38333',
    },
    orgIds: {
        pw: '5eb393ee95fab7468a79d189',
        neetPg: '63b5285395219c00126fa03d',
        curiousJr: '65a6574229b2581ba025c024',
        gyaane: '682fe3171a5f062f8f5851bf',
        unigo: '65203e91891e1296910d2c19',
        xylem: '642bea57241c6400199ad1e6',
        ezpay: '65203ee66c539a16ae356220',
        ias: '637f1d2bc8c48d00184c944a',
        ambassador: '65dc5778a2696c7fd76b702f',
        marvels: '64b9333f5d629000187dd48c',
        learnOs: '658e59733502bd5c441edcd8',
        talk: '66a13678862d321baf538838',
        scaleIndia: '66e3feac971bc77a13023d4d',
        ccs: '6721c86cca1218f4ef877fa6',
        nursingNext: '5ee9a14f0e10190011c078d1',
        disha: '6859283d682172331191b01e',
        pwmedharthi: '682e9a65600cb8d3b7440312',
        ycmou: '68886e07858959e616e78388',
    },
    isSecureLiveCreateEnabled: true,
    isDeleteChannelEnabled: false,
    isUsernameLoginEnabled: true,
    isMockAndRegularEnabled: true,
    isEnableQuestionPaperEnabled: true,
    isMentorJoinSessionsEnabled: true,
    isMentorReplaceTimeBound: false,
    isMultiRoleEnabled: true,
    firebase: FIREBASE_CONFIG,
    isSuper40Enabled: false,
    isLcmChatsEnabled: true,
    client_id:
        '626063976766-b8s9bf68eepiurla4dreq8s1l2gq56mi.apps.googleusercontent.com',
    saarthiFreelancers: SAARTHI_FREELANCERS,
    countryCodeAndName: 'https://countriesnow.space/api/v0.1/',
    odysseyUrl: 'https://studio-stage.pw.live',
    paidUserSegmentId: '65e8322ecfe58dcea768b3ac',
    freeUserSegmentId: '65e83179ecb50b03bab4471f',
    noBatchUserSegmentId: '65efdfe99ad9b1089842e66d',
    isNewWeeklyScheduleEnabledByDefault: true,
    uSocketUrl:
        'wss://central-socket-service-stage.penpencil.co/central-socket/ws',
    videoCookiesKey: {
        VIDEO_ENCRYPTION_KEY: 'pw3c199c2911cb437a907b1k0907c17n',
        INITIALISATION_VECTOR: '5184781c32kkc4e8',
    },
    slideImageUrl: 'https://slide-image-stage.physicswallah.live/',
    aiNcertProgramId: '6731eb68b5ade6a5f7227f8a',
    logsDashboard: 'https://metabase-prod.penpencil.co/dashboard/',
    financeExamEditAccessGiveTo: ['68186c6ec1ac89cca8302867'],
    batchCohortIdSC: '65c4f17c4853114a8c295b38',
    batchCohortIdEBC: '66e134a8d29278d658c82d03',
    batchCohortIdMM: '66f2e42e8d2e77a867cef01f',
    defaultVideoPlayerPoster:
        'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/7b8768ab-a16a-433a-a9fd-30f232596109.webp',
};

export const ENVIRONMENT_VARIABLES_DEVELOPMENT = {
    admin: 'https://admin-v2-dev.penpencil.co/',
    envType: 'dev',
    htmlResult: 'https://result-dev.penpencil.xyz/',
    mqttUrl: 'wss://emqx.penpencil.net/mqtt',
    multiBatchBaseUrl: 'https://batch-automation-dev.penpencil.co/',
    sdUIAppUrl: 'https://dev-sdui.penpencil.co',
    pwStoreApiBaseUrl: 'https://pw-store-dev.penpencil.co/',
    videoPlayerBaseUrl: 'https://static-dev-ycmou.penpencil.live/watch/',
    saarthiTeacherBaseUrl: 'https://sarthi-teacher-dev.penpencil.co/',
    clientBaseUrl: 'https://dev.physicswallah.live/',
    xylemClientBaseUrl: 'https://dev.xylem.live/',
    clientApiBaseUrl: 'https://dev-api.penpencil.co/',
    qbgBaseUrl: 'https://qbg-admin-dev.penpencil.co/',
    nuggetsBaseUrl: 'https://dev-pw-nuggetoverse-admin.penpencil.co/',
    pwTalkBaseUrl: 'https://pw-talk-dev.penpencil.co/',
    skillsAdminBaseUrl:
        'https://course-admin-fe-stage-ycmou.penpencil.live/courses',
    staticCdnUrl: 'https://static.pw.live/',
    defaultBatchCategoryIds: [
        '619bedb2394f824a71d8e687',
        '64140cb47ce1e200183332ae',
    ],
    productVariantByCategoryId: 'a89c31e5-4691-4012-b750-8e3c53f731d7',
    webinarId: '65701493ad71cf38c2ee884c',
    curiousjrK8WebinarId: '65c9dfe1e9bc8c2c56cb4f30',
    // [ PW REEL TAG ]
    reelTagIds: ['63f71395838107001f453887'],
    // [ PW Transcoding TAG ]
    transcodingTagIds: ['659e88a16b1a6f1da419afb2'],
    neetPgCatId: 'zdxdazhhsw0abuvnycwqi4ymb',
    podEMUserUId: '63b3fddfd6cacf0018b9a017',
    financeUserId: '',
    awsSecureVideoBaseUrl: 'https://d3nzo6itypaz07.cloudfront.net/',
    tataSecureVideoBaseUrl: 'https://xylem.pc.cdn.bitgravity.com/',
    roleIds: {
        // COMMON ROLES
        student: '5b27bd965842f950a778c6ef',
        parent: '5cc95a2e8bde4d66de400b37',
        teacher: '5b2b9742764bd519beb90ac2',
        admin: '5b27bd915842f950a778c6eb',
        school: '5dfa049b68d5946c0fa9b381',
        offlineCenterClient: '668f90bcf18fc7f8e9d36647',
        machineUser: '66a1ff1c51e24d48ebe0eca1',
        // PERMISSION ROLES
        academyAdmin: '6423e4ac55871ba2b4a6f454',
        academySuperAdmin: '6423eb2c55871ba2b4a6ff89',
        doubtSme: '636e43376e01d0001fa0588b',
        instituteHead: '640b060facaefe404d162f44',
        instituteTeacher: '64184b0bd67701e3d628f1f7',
        adminGlobalCMS: '651bcf3aa0c4f158bb1941c3',
        adminGyaaneCMS: '682fed014e768ecd391adb85',
        adminGyaaneCreatorCMS: '6848185fa9d3a4ade3deadd0',
        doubtSmeLead: '65ba17a31eeabed538f9ab79',
        operationsAmbassadorAdmin: '65e5836e588ee5017471364a',
        financeAmbassadorAdmin: '65e583be32754c5394cc338c',
        districtAmbassador: '671756429f03b8d1fa637a0b',
        callingAgent: '67175f99788c48248f6a0953',
        engagementSpoc: '67175fb641ccdfa063f54a7e',
        fieldSalesExecutive: '67175fd1788c48248f6a097b',
        referEarnAdmin: '67dc116d2dd6a4080864bcd9',
        // AUTH ROLES
        googleAuthQBG: '637af14a4612a70025a74f36',
        googleAuthSME: '637af17e5aeb2200250c4bbf',
        googleAuthAdmin: '637af18fce9e2f0025441102',
        googleAuthSaarthiTeacher: '637af1b50b128e00258c30cf',
        googleAuthZoomDashboard: '637af1cb5aeb2200250c4bc1',
        superAdmin: '5b27bd885842f950a778c6e7',
        // QBG ROLES
        sme: '629da730012cd250409f8a40',
        qc: '629da714012cd250409f8a3e',
        demand: '62c7c9fced282d5fe5fc6b65',
        dtpFreelancer: '660bd69be000814c2577ae81',
        qbgAdmin: '6397045f64588000252bc292',
        qbgSubAdmin: '64cb9b2c971b7a658455f7de',
        qbgDc: '6399784b0e8dae002591b8af',
        tagManager: '6487f75b2cc9c1b0b836e76d',
        // CRM/SST Roles
        sstSuperAdmin: '657adb78dc85ade8d9640b11',
        sstSuperAgentAlpha: '657adad7dc85ade8d9640b0f',
        sstSuperAgentBeta: '657adb2fdc85ade8d9640b10',
        sstAgent: '648018e7f8111f607a09cdb8',
        saathiOperationAdmin: '681311c30fa7ff9e03afeadd',
        saathiFinanceAdmin: '681311dc0fa7ff9e03afeadf',
        saathiApplicationManager: '681312050fa7ff9e03afeaf0',
        //skills roles
        skillsSuperAdmin: '6893a3ef2c44d931a52adfe1',
        skillsAdmin: '6893a40e2c44d931a52adfe5',
        skillsMentor: '6893a41d2c44d931a52adfee',
        skillsSales: '6893a4292c44d931a52adff0',
        skillsFinance: '6893a4351772e2776adba091',
        skillsTA: '6893a443a39dc4f2a0e38333',
    },
    orgIds: {
        pw: '5eb393ee95fab7468a79d189',
        neetPg: '63b525c5ea8da1001fc733f2',
        curiousJr: '65b20d787f643851023b9be9',
        gyaane: '682fe3171a5f062f8f5851bf',
        unigo: '65203e91891e1296910d2c19',
        xylem: '642bea57241c6400199ad1e6',
        ezpay: '65203ee66c539a16ae356220',
        ias: '637f1d2bc8c48d00184c944a',
        ambassador: '65dc5778a2696c7fd76b702f',
        marvels: '64b9333f5d629000187dd48c',
        learnOs: '658e59733502bd5c441edcd8',
        talk: '66a13678862d321baf538838',
        scaleIndia: '66e3feac971bc77a13023d4d',
        ccs: '6721c86cca1218f4ef877fa6',
        nursingNext: '5ee9a14f0e10190011c078d1',
        disha: '6859283d682172331191b01e',
        pwmedharthi: '682e9a65600cb8d3b7440312',
        ycmou: '68886e07858959e616e78388',
    },
    isSecureLiveCreateEnabled: false,
    isDeleteChannelEnabled: false,
    isUsernameLoginEnabled: true,
    isMockAndRegularEnabled: true,
    isEnableQuestionPaperEnabled: true,
    isMentorJoinSessionsEnabled: false,
    isMentorReplaceTimeBound: false,
    isMultiRoleEnabled: true,
    firebase: FIREBASE_CONFIG,
    isSuper40Enabled: false,
    isLcmChatsEnabled: true,
    client_id:
        '626063976766-b8s9bf68eepiurla4dreq8s1l2gq56mi.apps.googleusercontent.com',
    saarthiFreelancers: SAARTHI_FREELANCERS,
    countryCodeAndName: 'https://countriesnow.space/api/v0.1/',
    odysseyUrl: 'https://studio-dev.pw.live',
    paidUserSegmentId: '65e8322ecfe58dcea768b3ac',
    freeUserSegmentId: '65e83179ecb50b03bab4471f',
    noBatchUserSegmentId: '65efdfe99ad9b1089842e66d',
    isNewWeeklyScheduleEnabledByDefault: true,
    uSocketUrl: 'wss://central-socket-dev.penpencil.co/central-socket/ws',
    videoCookiesKey: {
        VIDEO_ENCRYPTION_KEY: 'pw3c199c2911cb437a907b1k0907c17n',
        INITIALISATION_VECTOR: '5184781c32kkc4e8',
    },
    slideImageUrl: 'https://slide-image-dev.physicswallah.live/',
    aiNcertProgramId: '6731eb68b5ade6a5f7227f8a',
    logsDashboard: 'https://metabase-prod.penpencil.co/dashboard/',
    financeExamEditAccessGiveTo: ['68186c6ec1ac89cca8302867'],
    defaultVideoPlayerPoster:
        'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/7b8768ab-a16a-433a-a9fd-30f232596109.webp',
};
